import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Client",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Utilisateurs",
      icon: "users",
      id: "users",
      component: "",
      path: "/admin/users",
      onClick: "",
      submenu: false,
      service: SERVICES.Privileges
    },
    {
      label: "Services",
      icon: "services",
      id: "services",
      component: "",
      path: "/admin/services",
      onClick: "",
      submenu: false,
      service: SERVICES.Privileges
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/admin/Menu.js